<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-form-item label="银行名称">
            <a-input v-model="queryParam.name" placeholder="请输入银行名称" allow-clear />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="table-operations" style="margin-bottom: 16px">
        <a-button type="primary" @click="$refs.createForm.handleAdd()"><a-icon type="plus" />新增银行</a-button>
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">
        <oss-img slot="logo" slot-scope="text" v-if="text" :src="text" class="thumb-img clickable" />
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1 || text === true" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确认删除该银行？" @confirm="handleDelete(record)">
            <a style="color:#ff4d4f">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
        @showSizeChange="changePage"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBank, delBank } from '@/api/user/bank'
import CreateForm from '@/views/user/bank/modules/CreateForm'

export default {
  name: 'GiftcardBank',
  components: { CreateForm },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      queryParam: { name: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '银行名称', dataIndex: 'name', width: 180 },
        { title: 'Logo', dataIndex: 'logo', scopedSlots: { customRender: 'logo' }, width: 90 },
        { title: '排序', dataIndex: 'sort', width: 80 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageBank(this.queryParam).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { name: undefined, pageNum: 1, pageSize: 10 }
      this.getList()
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleDelete(record) {
      delBank([{ id: record.id }]).then(() => {
        this.$message.success('删除成功')
        this.getList()
      })
    }
  }
}
</script>

<style scoped>
.thumb-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 4px;
}
.thumb-img.clickable {
  cursor: pointer;
}
</style>
